import { render } from "./FeeView.vue?vue&type=template&id=0106fee0"
import script from "./FeeView.vue?vue&type=script&lang=js"
export * from "./FeeView.vue?vue&type=script&lang=js"

import "./FeeView.vue?vue&type=style&index=0&id=0106fee0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__